// extracted by mini-css-extract-plugin
export default {"header":"Header_header__L4cqB","logo":"Header_logo__c7YyZ"};